export const isFullRow = (type: string): boolean =>
    type == "map" || type == "bigText" || type === "richText"
